import { graphql } from "@/graphql/codegen"
import "./customerPurchaseOrderFragments"

graphql(`
  query GetCustomerPurchaseOrderList($input: CustomerPurchaseOrderListInput!) {
    customerPurchaseOrder {
      list(input: $input) {
        __typename
        ... on CustomerPurchaseOrderListSuccess {
          customerPurchaseOrders {
            ...CustomerPurchaseOrderListItemFields
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on CustomerPurchaseOrderListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

// AK-5934 — seeds the line-items form with previously-saved products/lines when a CPO row expands
graphql(`
  query GetCustomerPurchaseOrderProducts($input: CustomerPurchaseOrderGetInput!) {
    customerPurchaseOrder {
      get(input: $input) {
        __typename
        ... on CustomerPurchaseOrderGetSuccess {
          customerPurchaseOrder {
            customerPurchaseOrderId
            products {
              ...CustomerPurchaseOrderProductFields
            }
          }
        }
        ... on CustomerPurchaseOrderGetFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
